<template>
  <mdb-container fluid>
    <div class="row pt-5 pb-3">
      <div class="col-md-3 mx-auto mb-4">
        <div class="card pt-0 card-cascade narrower">
          <div
            class="view view-cascade gradient-card-header mdb-color lighten-3"
          >
            <h5 class="mb-0 font-weight-bold">نوع درخواست</h5>
          </div>

          <div class="mt-2 card-body">
            <ul class="striped list-unstyled no-padding">
              <li class="hover" @click="setRequestType('WalletCharge')">
                <i v-show="form.RequestType == 'WalletCharge'" class="far fa-arrow-alt-circle-left text-primary "></i>
                <i v-show="form.RequestType != 'WalletCharge'" class="far fa-circle"></i>
                <span>شارژ کیف پول</span>
              </li>

              <li class="hover" @click="setRequestType('Invoice')">
                <i v-show="form.RequestType == 'Invoice'" class="far fa-arrow-alt-circle-left text-primary "></i>
                <i v-show="form.RequestType != 'Invoice'" class="far fa-circle"></i>
                <span>پرداخت فاکتور</span>
              </li>

              <li class="hover" @click="setRequestType('Service')">
                <i v-show="form.RequestType == 'Service'" class="far fa-arrow-alt-circle-left text-primary "></i>
                <i v-show="form.RequestType != 'Service'" class="far fa-circle"></i>
                <span>سفارش سرویس جدید</span>
              </li>

              <li class="hover" @click="setRequestType('Course')">
                <i v-show="form.RequestType == 'Course'" class="far fa-arrow-alt-circle-left text-primary "></i>
                <i v-show="form.RequestType != 'Course'" class="far fa-circle"></i>
                <span>ثبت نام در دوره</span>
              </li>

              <li class="hover" @click="setRequestType('Package')">
                <i v-show="form.RequestType == 'Package'" class="far fa-arrow-alt-circle-left text-primary "></i>
                <i v-show="form.RequestType != 'Package'" class="far fa-circle"></i>
                <span>درخواست پکیج</span>
              </li>

              <li class="hover" @click="setRequestType('Product')">
                <i v-show="form.RequestType == 'Product'" class="far fa-arrow-alt-circle-left text-primary "></i>
                <i v-show="form.RequestType != 'Product'" class="far fa-circle"></i>
                <span>درخواست نرم افزار عمومی</span>
              </li>

              <li class="hover hide" @click="setRequestType('Demo')">
                <i v-show="form.RequestType == 'Demo'" class="far fa-arrow-alt-circle-left"></i>
                <i v-show="form.RequestType != 'Demo'" class="far fa-circle"></i>
                <span>درخواست دمو</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-show="form.RequestType == 'WalletCharge'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 class="h4-responsive">شارژ کیف پول</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="d-flex flex-row">
                    <div class="col-10">
                      <mdb-textarea
                        :rows="5"
                        class="chat-message-type rtl"
                        label="اطلاعات فیش واریزی، شارژ کیف پول"
                        v-model="form.Body"
                      />
                      <mdb-chip
                        v-for="file in files"
                        v-bind:key="file.name"
                        @closeChip="removeFile(file)"
                        color="lighten-4"
                        close
                        >{{ file.name }}</mdb-chip
                      >
                    </div>

                    <div class="mt-5 col-2">
                      <small>پیوست اسکن فایل</small>
                      <mdb-file-input
                        floating
                        lg
                        icon="paperclip"
                        multiple
                        @getValue="selectFile"
                        btnColor="primary"
                        class="attach"
                      />
                      <mdb-btn
                        color="primary"
                        :disabled="posting"
                        @click="sendMessage"
                        size="lg"
                        >ثبت</mdb-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>

      <div v-show="form.RequestType == 'Invoice'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 class="h4-responsive">ثبت فیش واریزی برای فاکتور</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">

                  <div class="d-flex flex-row">
                    <div class="col-12">
                      <mdb-select
                        v-if="invoices!=null && invoices != []"
                        search
                        label="لطفا فاکتور خودتان را انتخاب کنید"
                        :options="invoices"
                        searchPlaceholder="جستجو"
                        :required="true"
                        @change="selectInvoice"
                      />
                    </div>
                  </div>  

                  <div class="d-flex flex-row">

                    <div class="col-10">
                      <mdb-textarea
                        :rows="5"
                        class="chat-message-type rtl"
                        label="اطلاعات فیش واریزی، فاکتور"
                        v-model="form.Body"
                      />
                      <mdb-chip
                        v-for="file in files"
                        v-bind:key="file.name"
                        @closeChip="removeFile(file)"
                        color="lighten-4"
                        close
                        >{{ file.name }}</mdb-chip
                      >
                    </div>

                    <div class="mt-5 col-2">
                      <small>پیوست اسکن فایل</small>
                      <mdb-file-input
                        floating
                        lg
                        icon="paperclip"
                        multiple
                        @getValue="selectFile"
                        btnColor="primary"
                        class="attach"
                      />
                      <mdb-btn
                        color="primary"
                        :disabled="posting"
                        @click="sendMessage"
                        size="lg"
                        >ثبت</mdb-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>

      <div v-show="form.RequestType == 'Service'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 class="h4-responsive">سفارش سرویس</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">

                  <div class="d-flex flex-row">
                    <div class="col-12">
                      <mdb-select
                        v-if="services!=null && services != []"
                        search
                        label="لطفا سرویس جدیدتان را انتخاب کنید"
                        :options="services"
                        searchPlaceholder="جستجو"
                        :required="true"
                        @change="selectService"
                      />
                    </div>
                  </div>  

                  <div class="d-flex flex-row">

                    <div class="col-10">
                      <mdb-textarea
                        :rows="5"
                        class="chat-message-type rtl"
                        label="اطلاعات سفارش شما"
                        v-model="form.Body"
                      />
                      <mdb-chip
                        v-for="file in files"
                        v-bind:key="file.name"
                        @closeChip="removeFile(file)"
                        color="lighten-4"
                        close
                        >{{ file.name }}</mdb-chip
                      >
                    </div>

                    <div class="mt-5 col-2">
                      <small>پیوست اسکن فایل</small>
                      <mdb-file-input
                        floating
                        lg
                        icon="paperclip"
                        multiple
                        @getValue="selectFile"
                        btnColor="primary"
                        class="attach"
                      />
                      <mdb-btn
                        color="primary"
                        :disabled="posting"
                        @click="sendMessage"
                        size="lg"
                        >ثبت</mdb-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>

      <div v-show="form.RequestType == 'Course'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 class="h4-responsive">ثبت نام برای دوره</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">

                  <div class="d-flex flex-row">
                    <div class="col-12">
                      <mdb-select
                        v-if="courses!=null && courses != []"
                        search
                        label="لطفا دوره مدنظر را انتخاب کنید"
                        :options="courses"
                        searchPlaceholder="جستجو"
                        :required="true"
                        @change="selectCourses"
                      />
                    </div>
                    
                  </div>  

                  <div class="d-flex flex-row" v-if="course!=null">
                    <div class="col-12">
                      <div class="alert alert-info">
                        <p>
                          <strong>وضعیت دوره : </strong> {{course.StatusName}}
                          <div class="alert alert-warning" v-show="course.StatusName=='به اتمام رسیده'">
                            با توجه به اتمام رسیدن دوره در صورت داشتن شرایط خاص این دوره دوباره ممکن هست برگذار شود وشما صرفاً پیش ثبت نام می نمایید
                          </div>
                        </p>
                        <p>
                          <strong>زبان : </strong> {{course.Language}}
                        </p>
                        <p>
                          {{course.Order}}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-row">

                    <div class="col-10">
                      <mdb-textarea
                        :rows="5"
                        class="chat-message-type rtl"
                        label="اطلاعات فیش واریزی، فاکتور ویا سوال مدنظرتان"
                        v-model="form.Body"
                      />
                      <mdb-chip
                        v-for="file in files"
                        v-bind:key="file.name"
                        @closeChip="removeFile(file)"
                        color="lighten-4"
                        close
                        >{{ file.name }}</mdb-chip
                      >
                    </div>

                    <div class="mt-5 col-2">
                      <small>پیوست اسکن فایل</small>
                      <mdb-file-input
                        floating
                        lg
                        icon="paperclip"
                        multiple
                        @getValue="selectFile"
                        btnColor="primary"
                        class="attach"
                      />
                      <mdb-btn
                        color="primary"
                        :disabled="posting"
                        @click="sendMessage"
                        size="lg"
                        >ثبت</mdb-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
      
      <div v-show="form.RequestType == 'Package'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 class="h4-responsive">سفارش پکیچ</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">

                  <div class="d-flex flex-row">
                    <div class="col-12">
                      <mdb-select
                        v-if="packages!=null"
                        search
                        label="لطفا پکیج را انتخاب کنید"
                        :options="packages"
                        searchPlaceholder="جستجو"
                        :required="true"
                        @change="selectPackage"
                      />
                    </div>
                  </div>  

                  <div class="d-flex flex-row">

                    <div class="col-10">
                      <mdb-textarea
                        :rows="5"
                        class="chat-message-type rtl"
                        label="توضیحات"
                        v-model="form.Body"
                      />
                      <mdb-chip
                        v-for="file in files"
                        v-bind:key="file.name"
                        @closeChip="removeFile(file)"
                        color="lighten-4"
                        close
                        >{{ file.name }}</mdb-chip
                      >
                    </div>

                    <div class="mt-5 col-2">
                      <small>پیوست اسکن فایل</small>
                      <mdb-file-input
                        floating
                        lg
                        icon="paperclip"
                        multiple
                        @getValue="selectFile"
                        btnColor="primary"
                        class="attach"
                      />
                      <mdb-btn
                        color="primary"
                        :disabled="posting"
                        @click="sendMessage"
                        size="lg"
                        >ثبت</mdb-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>

      <div v-show="form.RequestType == 'Product'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 class="h4-responsive">سفارش محصول</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">

                  <div class="d-flex flex-row">
                    <div class="col-12">
                      <mdb-select
                        v-if="products!=null"
                        search
                        label="لطفا محصول را انتخاب کنید"
                        :options="products"
                        searchPlaceholder="جستجو"
                        :required="true"
                        @change="selectProduct"
                      />
                    </div>
                  </div>  

                  <div class="d-flex flex-row">

                    <div class="col-10">
                      <mdb-textarea
                        :rows="5"
                        class="chat-message-type rtl"
                        label="توضیحات کامل از محصول مورد نیاز خود ارسال فرمایید"
                        v-model="form.Body"
                      />
                      <mdb-chip
                        v-for="file in files"
                        v-bind:key="file.name"
                        @closeChip="removeFile(file)"
                        color="lighten-4"
                        close
                        >{{ file.name }}</mdb-chip
                      >
                    </div>

                    <div class="mt-5 col-2">
                      <small>پیوست اسکن فایل</small>
                      <mdb-file-input
                        floating
                        lg
                        icon="paperclip"
                        multiple
                        @getValue="selectFile"
                        btnColor="primary"
                        class="attach"
                      />
                      <mdb-btn
                        color="primary"
                        :disabled="posting"
                        @click="sendMessage"
                        size="lg"
                        >ثبت</mdb-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>

      <div v-show="form.RequestType == 'Demo'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 class="h4-responsive">درخواست دمو</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">

                  <div class="d-flex flex-row">
                    <div class="col-12">
                      <mdb-select
                        v-if="products!=null"
                        search
                        label="لطفا محصول را انتخاب کنید"
                        :options="products"
                        searchPlaceholder="جستجو"
                        :required="true"
                        @change="selectProduct"
                      />
                    </div>
                  </div>  

                  <div class="d-flex flex-row">

                    <div class="col-10">
                      <mdb-textarea
                        :rows="5"
                        class="chat-message-type rtl"
                        label="توضیحات کامل سرویسی که مورد نیاز شماست ارسال فرمایید تا برسی و بعد از تایید دسترسی به دمو ان برای شما لحاظ گردد"
                        v-model="form.Body"
                      />
                      <mdb-chip
                        v-for="file in files"
                        v-bind:key="file.name"
                        @closeChip="removeFile(file)"
                        color="lighten-4"
                        close
                        >{{ file.name }}</mdb-chip
                      >
                    </div>

                    <div class="mt-5 col-2">
                      <small>پیوست اسکن فایل</small>
                      <mdb-file-input
                        floating
                        lg
                        icon="paperclip"
                        multiple
                        @getValue="selectFile"
                        btnColor="primary"
                        class="attach"
                      />
                      <mdb-btn
                        color="primary"
                        :disabled="posting"
                        @click="sendMessage"
                        size="lg"
                        >ثبت</mdb-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>

      <div v-show="form.RequestType == 'Payment'" class="col-md-8 mx-auto mb-4">
        <mdb-card>
          <mdb-card-body>
            <div class="p-4">
              <div class="row">
                <div class="col-sm-6 col-md-9 py-4 px-3">
                  <h4 v-show="errorMessage == true" class="h4-responsive">
                    در حال انتقال به درگاه بانکی ...
                  </h4>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  
                  <div v-show="errorMessage!==null" class="alert alert-danger" v-html="errorMessage">
                  </div>
                  
                </div>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>
      
    </div>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbIcon,
  mdbInput,
  mdbTextarea,
  mdbBtn,
  mdbSelect,
  mdbFileInput,
  mdbChip,
  mdbDatatable,
  mdbCard,
  mdbCardImage,
  mdbCardText,
  mdbCardBody,
} from "mdbvue";

import invoiceApi from "@/api/invoiceApi";
import systemApi from "@/api/systemApi";
import courseApi from "@/api/courseApi";
import productApi from "@/api/productApi";
import crmApi from "@/api/crmApi";

export default {
  name: "Support",
  components: {
    mdbContainer,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbSelect,
    mdbFileInput,
    mdbChip,
    mdbDatatable,
    mdbCard,
    mdbCardImage,
    mdbCardText,
    mdbCardBody,
  },
  data() {
    return {
      form: {
        RequestType: 1,
        InvoiceId: null,
        ServiceType: null, //
        CourseId: null,
        PackageId: null,
        ProductId: null,
      },
      course: null,
      files: [],
      posting: false,
      invoices: null,
      services: null,
      courses: null,
      courseItems: null,
      packages: null,
      products: null,
      errorMessage: null
    };
  },
  methods: {
    setRequestType(type) {
      this.form.RequestType = type;
    },
    selectFile(files) {
      if (files.length > 0) {
        this.$toastr.s( "پیوست شما با موفقیت انتخاب شد.","پیوست فایل");
        // var fileList = this.files
        // this.files = [];
        for (var i = 0; i < files.length; i++) {
          this.files.push(files[i]);
        }
        // this.files = files;
      }
    },
    removeFile(rfile) {
      var files = [];
      for (var i = 0; i < this.files.length; i++) {
        if (this.files[i].name != rfile.name) {
          files.push(this.files[i]);
        }
      }
      this.files = files;
    },
    sendMessage() {
      this.posting = true;

      let formData = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        formData.append("Files", this.files[i]);
      }
      formData.append("RequestType", this.form.RequestType);
      formData.append(
        "InvoiceId",
        this.form.InvoiceId == null ? 0 : this.form.InvoiceId
      );
      formData.append(
        "ServiceType",
        this.form.ServiceType == null ? 0 : this.form.ServiceType
      );
      formData.append(
        "CourseId",
        this.form.CourseId == null ? 0 : this.form.CourseId
      );
      formData.append(
        "PackageId",
        this.form.PackageId == null ? 0 : this.form.PackageId
      );
      formData.append(
        "ProductId",
        this.form.ProductId == null ? 0 : this.form.ProductId
      );
      formData.append("Body", this.form.Body);

      crmApi.sendRequest(formData).then(
        ({ data }) => {
          if (data.Status === 1) {
            this.form.Body = null;
            this.file = null;

            this.posting = false;
            this.$toastr.s(
              "درخواست شما با موفقیت ثبت شد و به زودی به آن پاسخ خواهیم داد.",
              "درخواست"
            );
            this.$router.push({ name: "Home" });
          } else {
            this.message = data.Message;
            this.posting = false;
            this.$toastr.e(data.Message,"درخواست");
          }
        },
        (r) => {
          var message = r.response.data.errors;
          this.posting = false;
          this.message = null;

          if (message.hasOwnProperty("Body")) {
            this.message = message.Body;
          }

          if (message.hasOwnProperty("Files")) {
            this.message = message.CaptchaInputText;
          }

          this.$toastr.e(
            "خطا در بارگذاری. لطفاً فایل مناسب را انتخاب کنید.",
            "ارسال تیکت"
          );
        }
      );
    },
    selectInvoice(value, text) {
      this.form.InvoiceId = value;
      // console.log(value, text);
    },
    selectService(value, text) {
      this.form.ServiceType = value;
      // console.log(value, text);
    },
    selectCourses(value, text) {
      this.form.CourseId = value;
      // console.log(value, text);
      for (var i = 0; i < this.courseItems.length; i++) {
        if (this.courseItems[i].CourseId == value) {
          this.course = this.courseItems[i];
          break;
        }
      }
    },
    selectPackage(value, text) {
      this.form.PackageId = value;
      // console.log(value, text);
    },
    selectProduct(value, text) {
      this.form.ProductId = value;
      // console.log(value, text);
    },
  },
  mounted() {
    console.log("mounted");
    this.form.RequestType = this.$route.params.type;

    if (this.form.RequestType == "WalletCharge") {
      //wallet
    } else if (this.form.RequestType == "Invoice") {
      // invoice
      var id = this.$route.params.id;
      this.form.InvoiceId = id;
    } else if (this.form.RequestType == "Service") {
      //services
      var id = this.$route.params.id;
      this.form.ServiceType = id;
    } else if (this.form.RequestType == "Course") {
      // course
      var id = this.$route.params.id;
      this.form.CourseId = id;
    } else if (this.form.RequestType == "Package") {
      //package
      var id = this.$route.params.id;
      this.form.PackageId = id;
    } else if (this.form.RequestType == "Product") {
      //product
      var id = this.$route.params.id;
      this.form.ProductId = id;
    } else if (this.form.RequestType == "Demo") {
      //demo
      var id = this.$route.params.id;
      this.form.ProductId = id;
    } else if (this.form.RequestType == "Payment") {
      let id = this.$route.params.id;
      invoiceApi.newInvoice(id).then(
            ({ data }) => {
              // console.log(data)
              if(data.Status == -1){
                this.errorMessage = "این محصول قابل سفارش نمی باشد"
              }
              else if (data.Status == 1){
                window.location.href = 'https://bndbs.ir/Payment/' + data.InvoiceId
                
                // this.$router.push({
                //   name: "Invoice",
                //   params: { invoiceId: data.InvoiceId },
                // });
              }
            },
            (r) => {}
          );
      
    }
  },
  computed: {},
  watch: {
    "form.RequestType": function (newValue, oldValue) {
      if (this.form.RequestType == "WalletCharge") {
        //wallet
      } else if (this.form.RequestType == "Invoice") {
        // invoice
        if (this.form.InvoiceId == null) {
          this.form.InvoiceId = this.$route.params.id;
        }
        if (this.invoices == null || this.invoices == []) {
          invoiceApi.getInvoiceByPayStatus(0).then(
            ({ data }) => {
              // console.log("data", data);
              this.invoices = [];
              for (var i = 0; i < data.length; i++) {
                this.invoices.push({
                  text: data[i].Name + " - " + data[i].FirstUpdate,
                  value: data[i].InvoiceId,
                  selected: data[i].InvoiceId == this.form.InvoiceId,
                });
              }
            },
            (r) => {}
          );
        }
      } else if (this.form.RequestType == "Service") {
        //services
        if (this.form.ServiceId == null) {
          this.form.ServiceId = this.$route.params.id;
        }
        let dashboard = this.$store.state.dashboard;

        if (dashboard.ServiceType == null) {
          console.log("step1");
          systemApi.getDashboard().then(
            ({ data }) => {
              console.log("step2", data);
              this.$store.state.dashboard = data;
              dashboard = this.$store.state.dashboard;

              this.services = [];
              for (var i = 0; i < dashboard.ServiceType.length; i++) {
                this.services.push({
                  text: dashboard.ServiceType[i].Text,
                  value: dashboard.ServiceType[i].Value,
                  selected:
                    dashboard.ServiceType[i].Value == this.form.ServiceType,
                });
              }
            },
            (r) => {}
          );
        } else {
          console.log("step3");
          this.services = [];
          for (var i = 0; i < dashboard.ServiceType.length; i++) {
            this.services.push({
              text: dashboard.ServiceType[i].Text,
              value: dashboard.ServiceType[i].Value,
              selected: dashboard.ServiceType[i].Value == this.form.ServiceType,
            });
          }
        }
      } else if (this.form.RequestType == "Course") {
        // course
        if (this.form.CourseId == null) {
          this.form.CourseId = this.$route.params.id;
        }

        if (this.courses == null || this.courses == []) {
          courseApi.getCourseList().then(
            ({ data }) => {
              this.courseItems = data;
              this.courses = [];
              for (var i = 0; i < data.length; i++) {
                this.courses.push({
                  text: data[i].Name,
                  value: data[i].CourseId,
                  selected: data[i].CourseId == this.form.CourseId,
                });
              }
            },
            (r) => {}
          );
        }
      } else if (this.form.RequestType == "Package") {
        //package
        if (this.form.PackageId == null) {
          this.form.PackageId = this.$route.params.id;
        }
        let dashboard = this.$store.state.dashboard;

        if (dashboard.Packages == null) {
          systemApi.getDashboard().then(
            ({ data }) => {
              this.$store.state.dashboard = data;

              dashboard = this.$store.state.dashboard;
              this.packages = [];
              for (var i = 0; i < dashboard.Packages.length; i++) {
                this.packages.push({
                  text: dashboard.Packages[i].Title,
                  value: dashboard.Packages[i].PackageId,
                  selected:
                    dashboard.Packages[i].PackageId == this.form.PackageId,
                });
              }
            },
            (r) => {}
          );
        } else {
          this.packages = [];
          for (var i = 0; i < dashboard.Packages.length; i++) {
            this.packages.push({
              text: dashboard.Packages[i].Title,
              value: dashboard.Packages[i].PackageId,
              selected: dashboard.Packages[i].PackageId == this.form.PackageId,
            });
          }
        }
      } else if (this.form.RequestType == "Product") {
        //product
        if (this.form.ProductId == null) {
          this.form.ProductId = this.$route.params.id;
        }
        if (this.products == null || this.products == []) {
          productApi.getProductList().then(
            ({ data }) => {
              this.products = [];
              for (var i = 0; i < data.length; i++) {
                this.products.push({
                  text: data[i].Name,
                  value: data[i].ProductId,
                  selected: data[i].ProductId == this.form.ProductId,
                });
              }
            },
            (r) => {}
          );
        }
      } else if (this.form.RequestType == "Demo") {
        //demo
        if (this.form.ProductId == null) {
          this.form.ProductId = this.$route.params.id;
        }
        if (this.products == null || this.products == []) {
          productApi.getProductList().then(
            ({ data }) => {
              this.products = [];
              for (var i = 0; i < data.length; i++) {
                this.products.push({
                  text: data[i].Name,
                  value: data[i].ProductId,
                  selected: data[i].ProductId == this.form.ProductId,
                });
              }
            },
            (r) => {}
          );
        }
      }
    },
    "$route.params": {
      handler(newValue) {
        this.form.RequestType = this.$route.params.type;

        if (this.form.RequestType == "WalletCharge") {
          //wallet
        } else if (this.form.RequestType == "Invoice") {
          // invoice
          var id = this.$route.params.id;
          this.form.InvoiceId = id;
        } else if (this.form.RequestType == "Service") {
          //services
          var id = this.$route.params.id;
          this.form.ServiceType = id;
        } else if (this.form.RequestType == "Course") {
          // course
          var id = this.$route.params.id;
          this.form.CourseId = id;
        } else if (this.form.RequestType == "Package") {
          //package
          var id = this.$route.params.id;
          this.form.PackageId = id;
        } else if (this.form.RequestType == "Product") {
          //product
          var id = this.$route.params.id;
          this.form.ProductId = id;
        } else if (this.form.RequestType == "Demo") {
          //demo
          var id = this.$route.params.id;
          this.form.ProductId = id;
        }
      },
      immediate: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1.1rem 1rem;
}

.card.card-cascade .view {
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2), 0 2px 8px 0 rgba(0, 0, 0, 0.19);
}
</style>
